<div class="button-wrapper">
  <span class="filter-label">{{
    'COMMON.LABEL.BUSINESS_UNITS' | translate
  }}</span>
  <p-multiSelect
    [options]="businessUnits"
    [(ngModel)]="selectedBusinessUnits"
    (onChange)="handleBusinessUnitChange($event)"
  />
</div>
